import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">{siteInfo.name}</h3>
            <p className="text-sm text-background-50/70 leading-relaxed mb-4">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">商品分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/articles" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">精选文章</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">常见问题</a></li>
              <li><a href="#" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-background-50/70">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5"></i>
                <span>{siteInfo.businessHours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 保留一切权利
          </p>
          <p className="text-xs text-background-50/50">
            <a href="#" className="hover:text-background-50/80 transition-colors">ICP备案号：沪ICP备XXXXXXXX号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}